/**
 * Two small helpers of the scripts, named after what they were: until 7.0.0 they carried the
 * fallbacks of Internet Explorer (document.createEvent() and initEvent() where CustomEvent was
 * no constructor, removeChild() where an element had no remove()), which every browser of the
 * browserslist of the build has done without for years (OUT-1). The names stay, since the scripts
 * call them in many places.
 */
export default class Polyfill {
    /**
     * Takes an element out of the page; an element which is in no page is left alone.
     */
    static removeHtmlElementNode(element: Element | null | undefined) {
        element?.remove();
    }

    /**
     * A custom event with its data as the detail, as the scripts of Event Gallery dispatch them
     * on the document.
     */
    static createNewEvent(eventName: string, data?: any): CustomEvent {
        return new CustomEvent(eventName, {detail: data});
    }
}
